import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { FallbackProps } from 'react-error-boundary'
import SeverErrorImg from '../../assets/img/500-sever-error.png'
import * as S from './styles'
import Search from '../../pages/Search'
import NotFound from '../../pages/NotFound'
import SearchContainer from '../../components/organisms/SearchContainer'

function ServerError() {
  return (
    <S.NotFoundWrapper>
      <S.NotFoundContent>
        <S.NotFoundImg alt="ServerErrorImg" src={SeverErrorImg} />
        <br />
        <S.NotFoundTitle>500 Server error</S.NotFoundTitle>
        <S.NotFoundText>Oops something went wrong.</S.NotFoundText>
      </S.NotFoundContent>
    </S.NotFoundWrapper>
  )
}

export const FallBack = ({ error, resetErrorBoundary }: FallbackProps) => {
  const { pathname } = useLocation()

  const [nowPath, setNowPath] = useState(pathname)
  useEffect(() => {
    if (error.response && nowPath !== pathname) {
      resetErrorBoundary()
    }
    setNowPath(pathname)
  }, [pathname])

  if (error.response) {
    const { status } = error.response
    if (status && status === 404) {
      return <NotFound />
    }
  }
  return (
    <>
      <SearchContainer>
        <Search />
      </SearchContainer>
      <ServerError />
    </>
  )
}
